import React, { useState, useContext } from 'react'
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import Select from 'react-select';
import FunctionsContext from "./FunctionsContext";

const Container = styled.div`
`;



const TextFieldsContainer = styled.div`
    display:grid;
    width:100%;
    grid-template-columns:1fr 20px 2fr;
    padding-left:20px;
    padding-right:20px;
    padding-top:20px;
`;

const BottomContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding-left:10px;
    padding-right:10px;
`;

const ButtonsContainer = styled.div`
    display:flex;
    align-items:center;
    padding-top : 10px;
`;

const ButtonContainer = styled.div`
    padding:5px;
`;

const CorporateContainer = styled.div`
    display:flex;
    align-items:center;
    justify-content:flex-start;
`;

const CorporateText = styled.div`
`;

const SelectContainer = styled.div`
display:grid;
width:100%
grid-template-columns:  auto 200px 1fr 2fr;
  align-items:center;
padding-left:10px;
padding-right:10px;
    padding-top:20px;
`;
const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        background: 'white'
    },
}));

const customStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused ? "rgb(61, 122, 150);" : null,
        boxShadow: 'none',
        border: state.isFocused ? '1.5px solid lightgray' : '1px solid lightgray', // default border color
        "&:hover": {
            borderColor: state.isFocused ? "rgb(61, 122, 150);" : "black"
        }
    }),
    menu: base => ({
        ...base,
        borderRadius: 0,
        marginTop: 0
    }),
    menuList: base => ({
        ...base,
        padding: 0,
        maxHeight: window.innerHeight - 300
    })
};
const CategoriesEditableItem = (cat) => {
    const classes = useStyles();
    const context = useContext(FunctionsContext)
    const currentUser = context.aboutCurrentUser;
    const currentGBUAdminGBUs = currentUser.permissions.filter(x => x.hasRole === true && x.scope === 'GBU' && x.assetId).map(t => t.assetId);
    const currentOmFunctions = currentUser.permissions.filter(x => x.hasRole === true && x.scope === 'FUNC' && x.assetId).map(t => t.assetId);

    let gbusList = context.functions.gbus && context.functions.gbus.map(gbus => {
        if (!((currentUser.isOM && currentOmFunctions.some(x => x === context.functions.selectedFunction.id)) || currentUser.isAdmin) && (currentUser.isGbuAdmin && currentGBUAdminGBUs.length > 0)) {
            if (currentGBUAdminGBUs.some(x => x === gbus.id)) {
                return { label: gbus.name, value: gbus.id }
            }
            else return null
        }
        else {
            return { label: gbus.name, value: gbus.id }
        }
    }).filter(y => y != null);
    gbusList.splice(0, 0, { label: 'None', value: 0 })

    const gbus = [
        {
            label: "GBUS",
            options: gbusList
        },
    ]
    const canCurrentUserEditCategories = ((currentUser.isGbuAdmin) || (currentUser.isOM && currentOmFunctions.some(x => x === context.functions.selectedFunction.id)) || currentUser.isAdmin);
    const canCurrentUserEditCoorporate = ((currentUser.isOM && currentOmFunctions.some(x => x === context.functions.selectedFunction.id)) || currentUser.isAdmin)

    const {
        id,
        isCorporate = false,
        name = "",
        description = "",
        procedureCount = 0,
        gbuid = 0,
    } = cat
    const [state, setState] = useState({ isCorporate, name, description, id, procedureCount, gbuid });
    const usercanaddcategory = state.name.length>0 && (state.isCorporate || state.gbuid>0 )
    
    return <Container>
        <TextFieldsContainer>
            <TextField
                required
                value={state.name}
                fullWidth
                inputProps={{ maxLength: 10 }}
                label="Procedure Category"
                variant="outlined"
                onChange={event => setState({ ...state, name: event.target.value })}
            />
            <div />
            <TextField
                value={state.description}
                onChange={event => setState({ ...state, description: event.target.value })}
                fullWidth
                inputProps={{ maxLength: 60 }}
                label="Brief Description"
                variant="outlined"
            />
        </TextFieldsContainer>
        <SelectContainer  >
            <CorporateText>
                New category for GBU?
            </CorporateText>
            <Select
                disabled={!canCurrentUserEditCategories}
                classes={classes}
                styles={customStyles}
                options={gbus}
                value={{ label: gbusList.find(x => x.value === state.gbuid).label }}
                onChange={event => setState({ ...state, gbuid: event.value, isCorporate: false })}
                placeholder="GBUS"
            />
        </SelectContainer>
        <BottomContainer>
            <CorporateContainer >
                <CorporateText>
                    Procedures require corporate-level approval
                </CorporateText>
                <Checkbox color="primary" disabled={!canCurrentUserEditCoorporate} checked={state.isCorporate} onChange={event => setState({ ...state, gbuid: 0, isCorporate: event.target.checked })} />
            </CorporateContainer>
            <ButtonsContainer>
                {state.id && !state.procedureCount &&
                    <ButtonContainer>
                        <IconButton color="primary" onClick={() => cat.onDelete({})}>
                            <DeleteIcon />
                        </IconButton>
                    </ButtonContainer>
                }
                <ButtonContainer>
                    <IconButton disabled={!usercanaddcategory} color="primary" onClick={() => cat.onConfirm({ ...state })}>
                        <CheckIcon />
                    </IconButton>
                </ButtonContainer>
                <ButtonContainer>
                    <IconButton color="primary" onClick={() => cat.onCancel()}>
                        <CloseIcon />
                    </IconButton>
                </ButtonContainer>
            </ButtonsContainer>
        </BottomContainer>
        <Divider />
    </Container>
}

export default CategoriesEditableItem;